<template>
  <div>
    <SearchDirectionInputs
      :dep="dep"
      :arr="arr"
      class="base-shadow"
      :source="source"
      :validation="validation"
      @onToInputClick="emit('onToInputClick')"
      @onFromInputClick="emit('onFromInputClick')"
      @onSwap="emit('onSwap')"
    />
    <SearchDateInputs
      class="inputs-block-shadow mt-2"
      :dates="dates"
      :source="source"
      @onDateSelect="emit('onDateSelect', $event)"
      @onDateClear="emit('onDateClear')"
    />
  </div>
</template>

<script setup lang="ts">
  import type { Validation } from '@vuelidate/core';
  import { SearchDirectionInputs } from 'freedom-shared';
  import type { searchFormCalendar, MappedLocation } from 'shared';

  import SearchDateInputs from './SearchDateInputs.vue';

  type DirectionValidator = Validation<{
    dep: {
      code: { requiredDep: boolean };
      isSameDeparture: boolean;
    };
    arr: {
      code: { requiredArr: boolean };
      isSameArrival: boolean;
    };
  }>;

  defineProps<{
    dep?: MappedLocation;
    arr?: MappedLocation;
    dates: string[];
    source: string;
    validation: DirectionValidator;
  }>();

  const emit = defineEmits<{
    onFromInputClick: [];
    onToInputClick: [];
    onSwap: [];
    onDateSelect: [mode: searchFormCalendar.config.CalendarMode];
    onDateClear: [];
  }>();
</script>
